module.exports = {
      id: "b1d448304241ec394dd5cc84fdc3060eroofShape-flat.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#b1d448304241ec394dd5cc84fdc3060eroofShape-flat.svg",
      toString: function () {
        return this.url;
      }
    }